import React from 'react';
import { MapPin, Phone, Clock } from 'lucide-react';
import { PRODUCT_NAV, getNavItem } from '../../data/categoryNav';
// Footer category links are derived from the shared category tree so they can
// never drift from the header nav or the internal category report.
const FOOTER_LABEL_OVERRIDES: Partial<Record<string, string>> = {
  commercial: 'Commercial Mailboxes',
  lighting: 'Lighting'
};
const [mailboxes, ...otherGroups] = PRODUCT_NAV;
const FOOTER_CATEGORY_LINKS = [{
  label: mailboxes.fullLabel,
  href: mailboxes.href
}, {
  label: getNavItem('mailboxes', 'Mailbox Posts').label,
  href: getNavItem('mailboxes', 'Mailbox Posts').href
}, ...otherGroups.map(group => ({
  label: FOOTER_LABEL_OVERRIDES[group.id] || group.fullLabel,
  href: group.href
})), {
  label: getNavItem('mailboxes', 'Mailbox Parts & Accessories').label,
  href: getNavItem('mailboxes', 'Mailbox Parts & Accessories').href
}];
export function Footer() {
  return <footer className="bg-brand-charcoal text-white pt-16 pb-24 lg:pb-12" data-id="element-511" data-mp="2kd4o4xhqrodw">
      <div className="max-w-7xl mx-auto px-4" data-id="element-512" data-mp="2kb08xjee72yb">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-[1.45fr_0.8fr_1fr_1.15fr_1.35fr] lg:gap-6 xl:gap-8 mb-12" data-id="element-513" data-mp="2p434ty6n6oho">
          {/* Brand Column */}
          <div className="space-y-6" data-id="element-514" data-mp="2gbj2onr561s3">
            <img src="https://www.midatlanticmailboxes.com/uploaded/images/Redesign/Logo%201.png" alt="MidAtlantic Mailboxes Logo" className="h-12 bg-white p-2 rounded" data-id="element-515" data-mp="2gckqztx64krr" />
            <p className="max-w-[320px] text-[#DAD7D2] text-sm leading-relaxed" data-id="element-516" data-mp="3825qq43w85b9">
              Residential mailboxes, commercial delivery systems, address
              plaques, decorative signs, replacement parts, and exterior
              accents.
            </p>
          </div>

          {/* Company Links */}
          <div data-id="element-517" data-mp="1ipu3azzh9xzs">
            <h4 className="font-serif text-lg font-semibold mb-6 text-brand-gold" data-id="element-518" data-mp="1nmuaje82d6sh">
              Company
            </h4>
            <ul className="space-y-3 text-sm text-[#E2DFDD]" data-id="element-519" data-mp="13l97chp05o6a">
              <li data-id="element-520" data-mp="13mtz5zjxmt0g">
                <a href="/AboutMidAtlanticMailboxInc.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-521" data-mp="zj4irxdevhqi">
                  About Us
                </a>
              </li>
              <li data-id="element-522" data-mp="psjje7pwy96j">
                <a href="/3949.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-523" data-mp="pt2r6vlunh6u">
                  Our Gallery
                </a>
              </li>
              <li data-id="element-524" data-mp="fxhsb6c2ux1b">
                <a href="/ContactUs.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-525" data-mp="bta7hk8qq18d">
                  Contact & FAQs
                </a>
              </li>
              <li data-id="element-526" data-mp="2669qlncbxdke">
                <a href="/OurPolicies" className="hover:text-brand-gold hover:underline transition-all" data-id="element-527" data-mp="266t8j41zc1yf">
                  Our Policies
                </a>
              </li>
            </ul>
          </div>

          {/* Resources Links */}
          <div data-id="element-528" data-mp="2dpizzgku5c9g">
            <h4 className="font-serif text-lg font-semibold mb-6 text-brand-gold" data-id="element-529" data-mp="2dp0sfnsq3bm8">
              Resources
            </h4>
            <ul className="space-y-3 text-sm text-[#E2DFDD]" data-id="element-530" data-mp="2ngne6e2ost38">
              <li data-id="element-531" data-mp="2ng3tiplnjqli">
                <a href="/Services.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-532" data-mp="2niq0oo4ms437">
                  Services
                </a>
              </li>
              <li data-id="element-533" data-mp="1zqt2w0y0ncl3">
                <a href="/13.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-534" data-mp="1zq9imdkw8c3w">
                  Install Instructions
                </a>
              </li>
              <li data-id="element-535" data-mp="3b67zv4q864g7">
                <a href="/USPSResources.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-536" data-mp="3b8u34s631xsm">
                  USPS Resources
                </a>
              </li>
              <li data-id="element-537" data-mp="38smbihaa86s1">
                <a href="/product-option-patterns.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-538" data-mp="38t4erxvd3l9g">
                  Product Option Patterns
                </a>
              </li>
              <li data-id="element-539" data-mp="kdvkoup8it8">
                <a href="/29.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-540" data-mp="jm2bkokqx64">
                  Catalog
                </a>
              </li>
              <li data-id="element-541" data-mp="a95op0bhx95q">
                <a href="/3948.html" className="hover:text-brand-gold hover:underline transition-all" data-id="element-542" data-mp="a9fdikkt1a9u">
                  Dominion Valley Community
                </a>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div data-id="element-543" data-mp="fb4qw6vi2013">
            <h4 className="font-serif text-lg font-semibold mb-6 text-brand-gold" data-id="element-544" data-mp="f777dk50f6go">
              Shop Categories
            </h4>
            <ul className="space-y-3 text-sm text-[#E2DFDD]" data-id="element-545" data-mp="12wf6lx7r3g53">
              {FOOTER_CATEGORY_LINKS.map(link => <li key={link.label} data-id="element-546" data-mp="oxp94gh0reg7">
                  <a href={link.href} className="hover:text-brand-gold hover:underline transition-all" data-id="element-547" data-mp="owmd5u4ualtf">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Contact Column */}
          <div data-id="element-548" data-mp="jznklg0tqmxc">
            <h4 className="font-serif text-lg font-semibold mb-6 text-brand-gold" data-id="element-549" data-mp="66oa5sfwfiwn">
              Contact Us
            </h4>
            <ul className="space-y-4 text-sm text-[#E2DFDD]" data-id="element-550" data-mp="a91f4emtncsd">
              <li className="flex items-start gap-3" data-id="element-551" data-mp="3sdmfsffz249s">
                <Phone size={18} className="shrink-0 mt-0.5 text-brand-gold" data-id="element-552" data-mp="3se4o4afws8y2" />
                <a href="tel:301-620-7585" className="hover:text-brand-gold transition-colors" data-id="element-553" data-mp="169ym0f39qtv">
                  301-620-7585
                </a>
              </li>
              <li className="flex items-start gap-3" data-id="element-554" data-mp="1y47ljy7x9dij">
                <MapPin size={18} className="shrink-0 mt-0.5 text-brand-gold" data-id="element-555" data-mp="1u3xeei8e8h23" />
                <span className="text-[#DAD7D2]" data-id="element-556" data-mp="1u1t5flvn0ruy">
                  MidAtlantic Mailbox, Inc.
                  <br data-id="element-557" data-mp="1p39gdclqyzyd" />
                  4507 Metropolitan Court Ste. D<br data-id="element-558" data-mp="2lubkvte2ur3q" />
                  Frederick, MD 21704
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-559" data-mp="2hv2w72xw9jf1">
                <Clock size={18} className="shrink-0 mt-0.5 text-brand-gold" data-id="element-560" data-mp="2cuoojm07gbhj" />
                <span className="text-[#DAD7D2]" data-id="element-561" data-mp="2cwrigh4haorj">
                  Office hours: Mon–Fri 10:30am–5:00pm ET
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-562" data-mp="11frrppxs4hzm">
                <Clock size={18} className="shrink-0 mt-0.5 text-brand-gold" data-id="element-563" data-mp="11d5d56ch127w" />
                <span className="text-[#DAD7D2]" data-id="element-564" data-mp="wf3uunmvd6xh">
                  After-hours support available until 8 PM Eastern Time
                  <br data-id="element-565" data-mp="manhq20ry3xd" />
                  <a href="tel:240-575-5852" className="text-white font-semibold hover:text-brand-gold transition-colors" data-id="element-566" data-mp="rb1nfdewl1s8">
                    240-575-5852
                  </a>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-[#DAD7D2]" data-id="element-567" data-mp="151y5497ajyki">
          <p data-id="element-568" data-mp="1a45i923uxkof">
            &copy; {new Date().getFullYear()} MidAtlantic Mailbox, Inc. All
            rights reserved.
          </p>
          <div className="flex items-center gap-4" data-id="element-569" data-mp="1k0s5tynkipu5">
            <span data-id="element-570" data-mp="1jzgzbr2qn3zc">Family-Owned</span>
            <span data-id="element-571" data-mp="3gssbt4le4079">•</span>
            <span data-id="element-572" data-mp="3gtk7efezlxxj">Woman-Owned</span>
          </div>
        </div>
      </div>
    </footer>;
}